import Vue from 'vue'
import supplyConfigTransformer from '@/transformers/catalog/warehouse/supplyConfig'

/**
 * @author jorge nuñez lópez <>
 *
 * Update supply configuration
 * @param newConfig New supply config object
 * @return {object}
 */

export default (newConfig) => {
  const { id } = newConfig
  const payload = supplyConfigTransformer.send(newConfig)
  return Vue.$http.put(`iwarehouse/supply-retrieve-update-delete/${id}/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/updateSupplyConfig.js